import { render } from "./IconTrekSuspension.vue?vue&type=template&id=d0a36d32"
import script from "./IconTrekSuspension.vue?vue&type=script&lang=js"
export * from "./IconTrekSuspension.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__